import {CURRENTTAB, NEWTAB} from '../../../insurance/healthInsurance/redux/action'
import {UPDATEDATAREPORTMODEL} from '../model/actionModel'
import {initialState} from '../model/initalState'
import {ActionTypes} from './actionTypes'

export const actions = {
  addNewTab: (tab: NEWTAB) => ({type: 'ADDNEWTAB', payload: tab}),
  removeTab: (tab: string) => ({type: 'REMOVETAB', payload: tab}),
  updateDataReport: (tab: UPDATEDATAREPORTMODEL) => ({type: 'UPDATEDATAREPORT', payload: tab}),
  modifyTab: (tab: CURRENTTAB) => ({type: 'MODIFYTAB', payload: tab}),
}

export const reportReducer = (state = initialState, action: ActionTypes) => {
  switch (action.type) {
    case 'ADDNEWTAB':
      const reportNewTabState = JSON.parse(JSON.stringify(state))
      if (state[0].tabName == undefined) {
        reportNewTabState[0].tabName = action.payload.tab
        reportNewTabState[0].sellingContractId = action.payload.tab
        reportNewTabState[0].customerCode = action.payload.customerCode
        reportNewTabState[0].customerVersion = action.payload.customerVersion
        reportNewTabState[0].groupDomainCode = action.payload.groupDomainCode
      } else {
        const obj = {
          tabName: action.payload.tab,
          sellingContractId: action.payload.tab,
          customerCode: action.payload.customerCode,
          customerVersion: action.payload.customerVersion,
          groupDomainCode: action.payload.groupDomainCode,
          dataReport: undefined,
        }
        reportNewTabState.push(obj)
      }
      return reportNewTabState
    case 'REMOVETAB':
      const tabState = JSON.parse(JSON.stringify(state))
      if (tabState.length === 1) {
        tabState[0].tabName = undefined
        tabState[0].sellingContractId = undefined
        tabState[0].customerCode = undefined
        tabState[0].customerVersion = undefined
        tabState[0].groupDomainCode = undefined
        tabState[0].dataReport = undefined
        return tabState
      }
      const tabRemoved = tabState.filter((o: any) => o.tabName !== action.payload)
      return tabRemoved
    case 'MODIFYTAB':
      const modifyTabState = JSON.parse(JSON.stringify(state))
      const currentModifyTab = modifyTabState.find(
        (o: any) => o.tabName == action.payload.currentTab
      )
      if (currentModifyTab) {
        currentModifyTab.sellingContractId = action.payload.newTabName
        currentModifyTab.customerCode = action.payload.customerCode
        currentModifyTab.customerVersion = action.payload.customerVersion
        currentModifyTab.groupDomainCode = action.payload.groupDomainCode        
      }
      return modifyTabState
    case 'UPDATEDATAREPORT':
      const dataState = JSON.parse(JSON.stringify(state))
      const tab = dataState.find((o: any) => o.tabName === action.payload.tab)
      if (tab) {
        tab.dataReport = action.payload.data
      }
      return dataState
    default:
      return state
  }
}

export function* saga() {}
